export default "__VITE_ASSET__acfe6e0a__"